import { settings } from "@/settings";
import { Picklist } from "@/types";
import { getOperator } from "../picklist";
import { globalConfig, headers, UON } from "@/utils";
import axios from "axios";
import Notify from 'quasar/src/plugins/Notify.js';;
import { api } from "@/auth/api";
import moment from "moment";


      export function searchDelegationList(filter: any, offset?: any, limit?: any): Promise<any[]> {
        return new Promise<any[]>((resolve, reject) => {
          const url = settings.api_query_url;
          const qc = getQcSearchDelegationList(filter, offset, limit)
          const _headers = headers({
            qc: JSON.stringify(qc)
          })
      axios
        .get(url, {
          headers: _headers,
        })
        .then((res) => {
            const response : any[] =[]
                 for (const resItem of res.data){
                    let userDelegatedFrom=resItem.user_delegated_from_first_name+' '+resItem.user_delegated_from_last_name
                    let userDelegatedTo=resItem.user_delegated_to_first_name+' '+resItem.user_delegated_to_last_name
                    const event={userDelegatedFrom:userDelegatedFrom,
                        userDelegatedTo:userDelegatedTo,
                        network_node_id:resItem.network_node_id,
                        network_id:resItem.network_id,
                        validity_from:resItem.validity_from,
                        validity_until:resItem.validity_until,
                        id:resItem.id
                    }

                    response.push(event)
                 }
          resolve(response)
        })
        .catch((err) => {
            Notify.create({
              message: `Query returned an error \n ${err}`,
              color: "negative",
            });
          });
      })
      }

  export function getQcSearchDelegationList(filter: any, offset?: any, limit?: any): any {
  
      const qc_header: any = {
        qc: {
          queryId: "delegation-search-filter",
          offset: offset || 0,
          limit: limit || 100,
        },
      };
      qc_header.qc.parameters = {
        ...filter,
      };
      const operators:any = [];

      if (filter && filter.userDelegatedFrom) {
        operators.push(getOperator("user_delegated_from", "id", "EQUAL", globalConfig.formatters.getEqualValue(filter.userDelegatedFrom), "id"))
      }
      if (filter && filter.userDelegatedTo) {
        operators.push(getOperator("user_delegated_to", "id", "EQUAL", globalConfig.formatters.getEqualValue(filter.userDelegatedTo), "id"))
      }
      if (filter && filter.network) {
              operators.push( getOperator("party_network_node","network_id", "EQUAL",globalConfig.formatters.getEqualValue(filter.network),"network_id"));
      }
      if (filter && filter.networkNode) {
        operators.push( getOperator("party_network_node","id", "EQUAL",globalConfig.formatters.getEqualValue(filter.networkNode),"id"));
      }
      
      if (operators.length > 0) {
        qc_header.qc.otherFilters = {
          expressions: [
            {
              and: {
                operators,
              },
            },
          ],
        };
      }
  
return qc_header.qc;
}
export async function getUserDelegation(resourceUid: any){
 const delegation = await getUserDelegationOrch(resourceUid)
 if(delegation.resourceUid){
    handleGetDelegation(delegation)
    
return delegation
 }
}

function handleGetDelegation(delegation:any){
    delegation.userDelegatedFrom.config={
        value:delegation.userDelegatedFrom.resourceUid,
        label:delegation.userDelegatedFrom.rawData.firstName+' '+delegation.userDelegatedFrom.rawData.lastName
    }
    delegation.userDelegatedTo.config={
        value:delegation.userDelegatedTo.resourceUid,
        label:delegation.userDelegatedTo.rawData.firstName+' '+delegation.userDelegatedTo.rawData.lastName
    }
    delegation.networkNode.config={
        value:delegation.networkNode.resourceUid,
        label:delegation.networkNode.resourceUid
    }

}
export function saveUserDelegation(delegation:any){
    handleSaveDelegation(delegation)
    if(delegation.resourceUid && delegation.resourceUid!=''){
        return updateUserDelegationOrch(delegation)
        
    }else{
        delete delegation.resourceUid
        return createUserDelegationOrch(delegation)

    }
}
function handleSaveDelegation(delegation:any){
    if(delegation.userDelegatedFrom.config && delegation.userDelegatedFrom.config.value){
        delegation.userDelegatedFrom.resourceUid=delegation.userDelegatedFrom.config.value
    }else if(delegation.userDelegatedFrom.config && !delegation.userDelegatedFrom.config.value){
        delegation.userDelegatedFrom.resourceUid=delegation.userDelegatedFrom.config
    }

    if(delegation.userDelegatedTo.config && delegation.userDelegatedTo.config.value){
        delegation.userDelegatedTo.resourceUid=delegation.userDelegatedTo.config.value
    }else if(delegation.userDelegatedTo.config && !delegation.userDelegatedTo.config.value){
        delegation.userDelegatedTo.resourceUid=delegation.userDelegatedTo.config
    }

    if(delegation.networkNode.config && delegation.networkNode.config.value){
        delegation.networkNode.resourceUid=delegation.networkNode.config.value
    }else if(delegation.networkNode.config && !delegation.networkNode.config.value){
        delegation.networkNode.resourceUid=delegation.networkNode.config
    }

    if(delegation.validity){
        delegation.validity.from ? delegation.validity.from = moment(delegation.validity.from,'DD/MM/YYYY').format("YYYY-MM-DD") : null;
        delegation.validity.until ? delegation.validity.until = moment(delegation.validity.until,'DD/MM/YYYY').format("YYYY-MM-DD") : null;
    }
    delegation.networkNode.rawData={}
    delegation.userDelegatedTo.rawData={}
    delegation.userDelegatedFrom.rawData={}
    delete delegation.networkNode.config
    delete delegation.userDelegatedTo.config
    delete delegation.userDelegatedFrom.config
    
}

export const createUserDelegationOrch = async (payload: any) => {
  const URI = `${settings.api_url}/${UON.SystemUid.odmOrchestration}/business-api/1/userDelegation/`;
  return (await api().post(URI,payload)).data
}
export const updateUserDelegationOrch = async (payload: any) => {
  const URI = `${settings.api_url}/${UON.SystemUid.odmOrchestration}/business-api/1/userDelegation/${payload.resourceUid}/`;
  return (await api().put(URI,payload)).data

}
export const getUserDelegationOrch = async (resourceUid: any) => {
  const URI = `${settings.api_url}/${UON.SystemUid.odmOrchestration}/business-api/1/userDelegation/${resourceUid}/`;
  return (await api().get(URI)).data
}